export default function Privacidade() {
  return (
    <div className="min-h-screen bg-white px-6 py-24">
      <div className="mx-auto max-w-2xl">
        <h1 data-testid="privacidade-title" className="font-display text-3xl font-medium tracking-tight text-charcoal md:text-4xl">
          Política de privacidade
        </h1>
      </div>
    </div>
  );
}
